import { ClientTypeEnum, LanguageEnum, SSETypeEnum, VoiceGenderTypeEnum } from '../../index.js'

/**
 * Sessions ID Request DTO
 * @param sessionID {string} Session ID
 */
export interface SessionsReq {
    /**
     * Session ID
     */
    session_id: string
}

/**
 * Sessions Create Request DTO
 * @param capacity {number} Capacity
 * @param genders {Array<VoiceGenderTypeEnum>} 性別陣列
 * @param languages {Array<LanguageEnum>} 語言陣列
 */
export interface SessionCreateRes {
    /**
     * Capacity
     */
    capacity: number
    /**
     * 性別陣列
     */
    genders: Array<VoiceGenderTypeEnum>
    /**
     * 語言陣列
     */
    languages: Array<LanguageEnum>
}

/**
 * Sessions TTS Request DTO
 * @extends {SessionsReq}
 * @param session_id {string} Session ID
 * @param language {LanguageEnum} Lang
 * @param gender {VoiceGenderTypeEnum} 聲音性別
 */
export interface SessionsTTSReq extends SessionsReq {
    /**
     * TTS的語言
     */
    language: LanguageEnum
    /**
     * 聲音性別
     */
    gender: VoiceGenderTypeEnum
}

/**
 * Sessions Events Request DTO
 * @extends {SessionsReq}
 * @param type {SSETypeEnum} 種類
 */
export interface SessionsEventsRes extends SessionsReq {
    /**
     * 種類
     */
    type: SSETypeEnum
}

/**
 * Sessions WS Request DTO
 * @extends {SessionsReq}
 * @param role {ClientTypeEnum} 使用者角色
 */
export interface SessionsWSReq extends SessionsReq {
    /**
     * 使用者角色
     */
    role?: ClientTypeEnum
    /**
     * Viewer ID
     */
    viewer_id: string
}

/**
 * Session MP4 Req
 * @extends SessionsTTSReq
 */
export interface SessionMP4Req extends SessionsTTSReq {
    /**
     * Message ID
     */
    message_id: string
}


/**
 * Session Summary Request DTO
 * @extends {SessionsReq}
 */
export interface SessionSummaryReq extends SessionsReq {
    /**
     * 語言
     */
    language: string
}

/**
 * Session History Request DTO
 * @extends {SessionsReq}
 * 支援以下四種查詢方式：
 * 1. 只帶 `session_id` 會取得全部
 * 2. 帶 `after` & `limit` 會取得特定時間內的特定筆數資料，用於要取得某個時間點之後的歷史資料
 * 3. 帶 `before` & `limit` 會取得特定時間內的特定筆數資料，用於往上捲動的歷史資料
 * 4. 帶 `limit` & `skip` 會取得特定分頁的資料
 */
export interface SessionHistoryReq extends SessionsReq {
    /**
     * 要取幾筆
     */
    limit?: number
    /**
     * 要從哪一筆開始取
     */
    skip?: number
    /**
     * 開始的時間
     * unix time 16位數
     */
    before?: number
    /**
     * 結束的時間
     * unix time 16位數
     */
    after?: number
}

/**
 * nchan SSE 直連請求 DTO
 */
export interface NchanConnectReq {
	/**
	 * 頻道 ID
	 */
	channel_id: string
	/**
	 * 唯一 viewer 識別碼；nchan 依此計算 unique viewer 數（sub / unsub hook）
	 */
	viewer_id: string
	/**
	 * 最後收到的 SSE event id（nchan etag）；重連時帶上讓 nchan 從 buffer 補發斷線期間訊息
	 */
	last_event_id?: string
}

